<template>
  <div class="c-medication-adherence-icon border px-1 py-3">
    <v-row align-center="center" align="center">
      <smart-icon
        icon="mdi-pill"
        :iconColor="color"
        size="26"
      />
    </v-row>
    <v-row align-center="center" align="center">
      <span
        class="c-medication-adherence-icon__text"
        :style="{ color: color }"
      >
        {{text}}
      </span>
    </v-row>
  </div>
</template>

<script>
import SmartIcon from "./SmartIcon.vue";

/**
 * Component MedicationAdherenceIcon.vue
 *
 * @module MedicationAdherenceIcon
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.6] app/src/APP_DASHBOARD/templates/components/Parts/MedicationAdherenceIcon.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  components: { SmartIcon },
  name: "MedicationAdherenceIcon",
  props: {
    color:{},
    text:{},
  },
};
</script>

<style lang="scss">
.c-medication-adherence-icon {
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}

.c-medication-adherence-icon__text {
  font-weight: bold;
}
</style>